import { z } from "zod/v4";
import {
  createOverviewSearchSchema,
  overviewFilterOperator,
  overviewFilterValues,
} from "#/modules/util.overview/schema.search";

/**
 * Search params schema for the schools admin overview: searchTerm, sort, licentieType filter
 * (enum-name array + in/notIn operator), verwerkersovereenkomst filter ("true"/"false"),
 * pagination.
 */
const { schema, defaults } = createOverviewSearchSchema({
  // Newest schools first: the admin list is used to check what was just created.
  orderBy: "createdAt",
  orderDirection: "descending",
  extra: {
    licentieType: overviewFilterValues(),
    licentieTypeOperator: overviewFilterOperator(),
    verwerkersovereenkomst: overviewFilterValues(),
  },
});

export const schoolsAdminSearchSchema = schema;

/** Default values for schools admin search params; values not explicitly set will be omitted from URL. */
export const SCHOOLS_ADMIN_SEARCH_DEFAULTS = defaults;

export type SchoolsAdminSearch = z.infer<typeof schoolsAdminSearchSchema>;
